module.exports = "/_next/static/images/d847d6e37ef6adea35ddb01409bcac66-hero-100m-tablet.jpg";